/**
 * Headline text with highlighted words. Wrap the words in asterisks:
 * "Stop fighting software that was never *built for you.*" The highlight is
 * Golden Sun (Cobalt on light grounds); `.brush` headlines add the stroke.
 */
export default function Accent({ children }) {
  if (typeof children !== "string") return children;
  return children.split(/(\*[^*]+\*)/).map((part, i) =>
    part.startsWith("*") && part.endsWith("*") ? (
      <em key={i} className="accent">
        {part.slice(1, -1)}
      </em>
    ) : (
      part
    ),
  );
}

/** The headline without its asterisks, for <title> and alt text. */
export const plain = (text = "") => text.replace(/\*/g, "");
